import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { LoggerService } from '@app/logger/logger.service';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from '@app/material.module';
const log = new LoggerService('CANCEL-DIALOG COMPONENT')

@Component({
  standalone: true,
  imports: [
    FormsModule,
    ReactiveFormsModule,
    MaterialModule
],
  selector: 'app-order-dialog',
  templateUrl: './order-dialog.component.html',
  styleUrls: ['./order-dialog.component.scss'],
})
export class OrderDialog {
  public record = null;
  public doctorObject = null;
  public patientObject = null;
  public procedureObject = null;
  public specialtyObject = null;
  public displayedColumns: string[] = ['itemCode', 'itemDescription', 'quantity','delivery','consumption','refund','type'];
  public substituteList = null;

  // Mapa de categorías con su label y datasource
  public categoryTables: { key: string, label: string, dataSource: MatTableDataSource<any> }[] = [];

  // Labels legibles por categoría
  private categoryLabels: Record<string, string> = {
    products: 'Insumos',
    equipments: 'Equipos',
    medicines: 'Medicamentos',
    instrumentals: 'Instrumental',
  };

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<OrderDialog>
  ) { }

  async ngOnInit() {
    this.record = this.data['record'];
    this.doctorObject = this.data['doctor'];
    this.specialtyObject = this.data['specialty'];
    this.patientObject = this.data['patient'];
    this.procedureObject = this.data['procedure'];

    const categories = ['products', 'equipments', 'medicines', 'instrumentals'];
    const request = this.record['request'];

    // Por cada categoría, si existe y tiene elementos, crear una tabla
    if (request != null && typeof request === 'object') {
      for (const category of categories) {
        if (
          Array.isArray(request[category]) &&
          request[category].length > 0
        ) {
          this.categoryTables.push({
            key: category,
            label: this.categoryLabels[category] || category,
            dataSource: new MatTableDataSource(request[category])
          });
        }
      }
    }

  }

  public formatDate(dateString: string): string {
    const testDate = new Date(dateString);
    return testDate.toLocaleDateString('es-ES', {
      day: '2-digit',
      month: 'long',
      year: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
    });
  }

  prevale() {
    this.dialogRef.close({ clicked: 'prevale' });
  }

  order() {
    this.dialogRef.close({ clicked: 'order' });
  }
}